import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideRotating = ({ width = 48, height = 48, color = '#000000' }) =>
    <svg width={width} height={height} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M10 15V39H45V15H10Z' stroke={color} strokeWidth='2' strokeMiterlimit='10' strokeLinejoin='bevel' />
        <path d='M10 32H6V29H3V25H6V22H10' stroke={color} strokeWidth='2' strokeMiterlimit='10' strokeLinecap='square' strokeLinejoin='bevel' />
        <path d='M41 45H14L15 39H40L41 45Z' stroke={color} strokeWidth='2' strokeMiterlimit='10' strokeLinecap='square' strokeLinejoin='bevel' />
        <path d='M17 35V19M38 19V35M14 19H41M14 23H17M14 31H17M14 35H41M38 23H41M38 31H41' stroke={color} strokeWidth='2' strokeMiterlimit='10' strokeLinejoin='bevel' />
        <path d='M22 11H37L33 15H18L22 11Z' stroke={color} strokeWidth='2' strokeMiterlimit='10' strokeLinejoin='bevel' />
        <path d='M3 6C4.7 4.3 7 3 10 3C13 3 15.4 4.3 17 6M6 9C6.8 8.2 8 7 10 7C12 7 13.2 8.2 14 9' stroke={color} strokeWidth='2' />
        <path d='M17 27H22L23 23L25.4 32L28 22L31 32L33 25L33.7 28.3H38' stroke={color} strokeWidth='2' strokeLinejoin='bevel' />
    </svg>;

IconPowertrainGuideRotating.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideRotating;
